import RestaurantCard, { withPromotedLabel } from "./RestaurantCard";
import { useState, useEffect, useContext } from "react";
import resList from "../utils/mockData";
import Shimmer from "./Shimmer";
import { Link } from "react-router-dom";
import useOnlineStatus from "../utils/useOnlineStatus";
import UserContext from "../utils/UserContext";


// const listOfRestaurant=[
//     {
//         data: {
//           id: "78036",
//           name: "Burger King",
//           cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
//           locality: "Central Plaza, Kalina",
//           areaName: "Santacruz East",
//           costForTwo: 35000,
//           costForTwoString: "₹350 for two",
//           deliveryTime: 24,
//           cuisines: ["Burgers", "American"],
//           avgRating: 3.2,
//           feeDetails: {
//             restaurantId: "78036",
//             fees: [
//               {
//                 name: "BASE_DISTANCE",
//                 fee: 3200,
//               },
//               {
//                 name: "BASE_TIME",
//               },
//               {
//                 name: "ANCILLARY_SURGE_FEE",
//               },
//             ],
//             totalFee: 3200,
//           },
//           parentId: "166",
//           avgRatingString: "4.2",
//           totalRatingsString: "10K+",
//           sla: {
//             lastMileTravel: 1.5,
//             serviceability: "SERVICEABLE",
//             slaString: "24 mins",
//             lastMileTravelString: "1.5 km",
//             iconType: "ICON_TYPE_EMPTY",
//           },
//           availability: {
//             nextCloseTime: "2023-11-30 03:45:00",
//             opened: true,
//           },
//           badges: {},
//           isOpen: true,
//           type: "F",
//           badgesV2: {
//             entityBadges: {
//               imageBased: {},
//               textBased: {},
//               textExtendedBadges: {},
//             },
//           },
//           aggregatedDiscountInfoV3: {
//             header: "ITEMS",
//             subHeader: "AT ₹129",
//           },
//           differentiatedUi: {
//             displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             differentiatedUiMediaDetails: {
//               mediaType: "ADS_MEDIA_ENUM_IMAGE",
//               lottie: {},
//               video: {},
//             },
//           },
//           reviewsSummary: {},
//           displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           restaurantOfferPresentationInfo: {},
//         },
//         analytics: {},
//         cta: {
//           link: "https://www.swiggy.com/restaurants/burger-king-central-plaza-kalina-santacruz-east-mumbai-78036",
//           type: "WEBLINK",
//         },
//       },
//       {
//         data: {
//           id: "32399",
//           name: "McDonald's",
//           cloudinaryImageId: "bb7ae131544c7d37e10fc5faf76f09d6",
//           locality: "Kalina Artista",
//           areaName: "Santacruz East",
    
//           costForTwo: 40000,
//           costForTwoString: "400 for two",
//           deliveryTime: 17,
//           cuisines: ["Burgers", "Beverages", "Cafe", "Desserts"],
//           avgRating: 4.3,
//           feeDetails: {
//             restaurantId: "32399",
//             fees: [
//               {
//                 name: "BASE_DISTANCE",
//                 fee: 3900,
//               },
//               {
//                 name: "BASE_TIME",
//               },
//               {
//                 name: "ANCILLARY_SURGE_FEE",
//               },
//             ],
//             totalFee: 3900,
//           },
//           parentId: "630",
//           avgRatingString: "4.3",
//           totalRatingsString: "10K+",
//           sla: {
//             lastMileTravel: 1.5,
//             serviceability: "SERVICEABLE",
//             slaString: "17 mins",
//             lastMileTravelString: "1.5 km",
//             iconType: "ICON_TYPE_EMPTY",
//           },
//           availability: {
//             nextCloseTime: "2023-11-30 03:00:00",
//             opened: true,
//           },
//           badges: {
//             textExtendedBadges: [
//               {
//                 iconId: "guiltfree/GF_Logo_android_3x",
//                 shortDescription: "options available",
//                 fontColor: "#7E808C",
//               },
//             ],
//           },
//           isOpen: true,
//           type: "F",
//           badgesV2: {
//             entityBadges: {
//               imageBased: {},
//               textBased: {},
//               textExtendedBadges: {
//                 badgeObject: [
//                   {
//                     attributes: {
//                       description: "",
//                       fontColor: "#7E808C",
//                       iconId: "guiltfree/GF_Logo_android_3x",
//                       shortDescription: "options available",
//                     },
//                   },
//                 ],
//               },
//             },
//           },
//           aggregatedDiscountInfoV3: {
//             header: "10% OFF",
//             subHeader: "ABOVE ₹1000",
//             discountTag: "FLAT DEAL",
//           },
//           differentiatedUi: {
//             displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             differentiatedUiMediaDetails: {
//               mediaType: "ADS_MEDIA_ENUM_IMAGE",
//               lottie: {},
//               video: {},
//             },
//           },
//           reviewsSummary: {},
//           displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           restaurantOfferPresentationInfo: {},
//         },
//         analytics: {},
//         cta: {
//           link: "https://www.swiggy.com/restaurants/mcdonalds-kalina-artista-santacruz-east-mumbai-32399",
//           type: "WEBLINK",
//         },
//       },
//       {
//         data: {
//           id: "82668",
//           name: "The Belgian Waffle Co.",
//           cloudinaryImageId: "846dab8cca3c56a482d7cbcda0dd0eb9",
//           locality: "Kalina",
//           areaName: "Santacruz East",
//           costForTwoString: "₹200 for two",
//           costForTwo: 20000,
//           deliveryTime: 32,
//           cuisines: ["Waffle", "Desserts", "Ice Cream", "Beverages"],
//           avgRating: 4.3,
//           veg: true,
//           feeDetails: {
//             restaurantId: "82668",
//             fees: [
//               {
//                 name: "BASE_DISTANCE",
//                 fee: 3200,
//               },
//               {
//                 name: "BASE_TIME",
//               },
//               {
//                 name: "ANCILLARY_SURGE_FEE",
//               },
//             ],
//             totalFee: 3200,
//           },
//           parentId: "2233",
//           avgRatingString: "4.3",
//           totalRatingsString: "1K+",
//           sla: {
//             lastMileTravel: 1.5,
//             serviceability: "SERVICEABLE",
//             slaString: "32 mins",
//             lastMileTravelString: "1.5 km",
//             iconType: "ICON_TYPE_EMPTY",
//           },
//           availability: {
//             nextCloseTime: "2023-11-30 04:00:00",
//             opened: true,
//           },
//           badges: {},
//           isOpen: true,
//           type: "F",
//           badgesV2: {
//             entityBadges: {
//               imageBased: {},
//               textBased: {},
//               textExtendedBadges: {},
//             },
//           },
//           aggregatedDiscountInfoV3: {
//             header: "40% OFF",
//             subHeader: "UPTO ₹80",
//           },
//           differentiatedUi: {
//             displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             differentiatedUiMediaDetails: {
//               mediaType: "ADS_MEDIA_ENUM_IMAGE",
//               lottie: {},
//               video: {},
//             },
//           },
//           reviewsSummary: {},
//           displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           restaurantOfferPresentationInfo: {},
//         },
//         analytics: {},
//         cta: {
//           link: "https://www.swiggy.com/restaurants/the-belgian-waffle-co-kalina-santacruz-east-mumbai-82668",
//           type: "WEBLINK",
//         },
//       },
// ];


const Body =()=>{

    //UseState
    //Local State Variable - Super powerful variable
   // const [listOfRestaurants, setListOfRestaurant] = useState(resList);    //resList old data
   const [listOfRestaurants, setListOfRestaurant] = useState([]);   //resList is empty now

   const [filteredRestaurant, setFilteredRestaurant] = useState([]);

   const [searchText, setSearchText]=useState("");

   const RestaurantCardPromoted=withPromotedLabel(RestaurantCard);

   //Whenever state variable update, react triggers a reconciliation cycle(re render the component) 
    console.log("Body rendered again and again");

    //Normal Js variable
    // let resList = [];

    //UseEffect
    //2 arguments- call back function and dependency array
    useEffect(() => {
        // console.log("useEffect rendered");
        fetchData();
    }, []);

    const fetchData = async () => {
       
      //  const data=await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=19.2069473&lng=73.1034258&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
      const data=await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=19.2069473&lng=73.1034258&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
      
      const json = await data.json();
      
      console.log(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);

      setListOfRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
          // setListOfRestaurant(json.data.cards[1].card.card.gridElements.infoWithStyle.restaurants);
        // setListOfRestaurant(json.data.cards[4].card.card.gridElements.infoWithStyle.restaurants);
      setFilteredRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);   
    };

    // console.log("Body rendered");

    //Conditioanal Rendering 
    // if(listOfRestaurants.length ===0){
    //    // return <h3>Loading.........</h3>;
    //   return <Shimmer/>
    // }

    const onlineStatus=useOnlineStatus();

    if(onlineStatus == false) {
        return (
        <h1>Looks like you are offline!! Please check your internet connection;
        </h1>
        );
    }

    const {loggedInUser, setUserName}=useContext(UserContext);
    //Ternary Condition
    return listOfRestaurants.length === 0 ? (<Shimmer/>) : (
        <div className="body">
       
            <div className="filter flex flex-wrap pt-24 justify-center">
                <div className="search px-5 my-7 flex">
                    <input type="text" data-testid = "searchInput" className="border border-solid border-black rounded-lg" value={searchText} onChange={(e)=>{
                        setSearchText(e.target.value);
                    }}/>
                    <button className="px-5 py-0 mx-3 rounded-lg bg-orange-600 text-white hover:text-black font-semibold" onClick={()=>{
                        //Filter the restaurant cards and update the UI
                        //searchText
                        console.log(searchText);

                       const filteredRestaurant = listOfRestaurants.filter((res)=>res.info.name.toLowerCase().includes(searchText.toLowerCase()));

                       // setListOfRestaurant(filteredRestaurant);
                       setFilteredRestaurant(filteredRestaurant);
                    }}>Search</button>
                </div>
                <button className="px-5 py-2 my-7 rounded-lg bg-orange-600 text-white hover:text-black font-semibold" onClick={
                    ()=>{
                        const filterList=listOfRestaurants.filter((res)=>res.info.avgRating > 4.3);

                        console.log(filterList);
                         //setListOfRestaurant(filterList);
                        setFilteredRestaurant(filterList);
                    }
                }>Top Rated Restaurants</button>

                {/* <button className="px-5 py-1 my-7">
                    UserName : <input className="border border-black" value= { loggedInUser} onChange={(e)=> setUserName(e.target.value)} />
                </button> */}
            </div>
            <div className="res-container flex flex-wrap justify-start sm:px-0 lg:px-40">
            {/* <RestaurantCard resName="KFC" cuisine="Burger, Fast Food"/> */}

            {/* <RestaurantCard resData={resObj} /> */}

            {/* <RestaurantCard resData={resList[0]}/>
            <RestaurantCard resData={resList[1]}/>
            <RestaurantCard resData={resList[2]}/> */}
           
             {/* resList.map((restaurant)=>( */}

           {/* listOfRestaurants.map((restaurant)=>( */}

            {filteredRestaurant.map((restaurant)=>(
           <Link key={restaurant.info.id} to={"/restaurants/"+ restaurant.info.id}>
           
           {
                restaurant.info.promoted ? (<RestaurantCardPromoted resData={restaurant} />) : (<RestaurantCard resData={restaurant} />)
           }

           </Link>
           ))}
            </div>
            </div>
       
    );
  };

  export default Body;